module.exports = __webpack_public_path__ + "img/img-3-14.9333e0a4.png";